module.exports = __webpack_public_path__ + "static/img/RebateIcon.dacfa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/RebateIcon.png
// module id = R30J
// module chunks = 39